import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import RequireSuperAdmin from "@/components/RequireSuperAdmin";

import Landing from "@/pages/Landing";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import { ForgotPassword, ResetPassword } from "@/pages/auth/ResetPassword";

import DashboardLayout from "@/components/dashboard/DashboardLayout";
import DashboardHome from "@/pages/dashboard/DashboardHome";
import EventsList from "@/pages/dashboard/EventsList";
import EventNew from "@/pages/dashboard/EventNew";
import EventEdit from "@/pages/dashboard/EventEdit";
import EventLayout from "@/pages/dashboard/EventLayout";
import EventOverview from "@/pages/dashboard/event/EventOverview";
import EventSessions from "@/pages/dashboard/event/EventSessions";
import EventAttendees from "@/pages/dashboard/event/EventAttendees";
import EventQuestions from "@/pages/dashboard/event/EventQuestions";
import EventPolls from "@/pages/dashboard/event/EventPolls";
import EventFeedback from "@/pages/dashboard/event/EventFeedback";
import EventSurveys from "@/pages/dashboard/event/EventSurveys";
import EventReports from "@/pages/dashboard/event/EventReports";
import EventSettings from "@/pages/dashboard/event/EventSettings";
import Team from "@/pages/dashboard/Team";
import OrgSettings from "@/pages/dashboard/OrgSettings";

import SuperAdminLayout from "@/pages/superadmin/SuperAdminLayout";
import SuperAdminHome from "@/pages/superadmin/SuperAdminHome";
import SuperAdminOrgs from "@/pages/superadmin/SuperAdminOrgs";
import SuperAdminOrgDetail from "@/pages/superadmin/SuperAdminOrgDetail";

import AttendeeEvent from "@/pages/attendee/AttendeeEvent";
import AttendeeSession from "@/pages/attendee/AttendeeSession";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Attendee mobile experience (public) */}
            <Route path="/attendee/:eventId" element={<AttendeeEvent />} />
            <Route path="/attendee/:eventId/session/:sessionId" element={<AttendeeSession />} />

            {/* Super Admin control plane */}
            <Route element={<RequireSuperAdmin><SuperAdminLayout /></RequireSuperAdmin>}>
              <Route path="/super-admin" element={<SuperAdminHome />} />
              <Route path="/super-admin/organisations" element={<SuperAdminOrgs />} />
              <Route path="/super-admin/organisations/:id" element={<SuperAdminOrgDetail />} />
            </Route>

            {/* Organisation workspace (protected) */}
            <Route element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
              <Route path="/dashboard" element={<DashboardHome />} />
              <Route path="/events" element={<EventsList />} />
              <Route path="/events/new" element={<EventNew />} />
              <Route path="/events/:id/edit" element={<EventEdit />} />
              <Route path="/events/:id" element={<EventLayout />}>
                <Route index element={<EventOverview />} />
                <Route path="sessions" element={<EventSessions />} />
                <Route path="attendees" element={<EventAttendees />} />
                <Route path="questions" element={<EventQuestions />} />
                <Route path="polls" element={<EventPolls />} />
                <Route path="feedback" element={<EventFeedback />} />
                <Route path="surveys" element={<EventSurveys />} />
                <Route path="reports" element={<EventReports />} />
                <Route path="settings" element={<EventSettings />} />
              </Route>
              <Route path="/team" element={<Team />} />
              <Route path="/settings" element={<OrgSettings />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
